var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0694A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26C14.9 26 14.01 26.9 14.01 28C14.01 29.1 14.9 30 16 30C17.1 30 18 29.1 18 28C18 26.9 17.1 26 16 26ZM10 10V12H12L15.6 19.59L14.25 22.04C14.09 22.32 14 22.65 14 23C14 24.1 14.9 25 16 25H28V23H16.42C16.28 23 16.17 22.89 16.17 22.75L16.2 22.63L17.1 21H24.55C25.3 21 25.96 20.59 26.3 19.97L29.88 13.48C29.96 13.34 30 13.17 30 13C30 12.45 29.55 12 29 12H14.21L13.27 10H10ZM26 26C24.9 26 24.01 26.9 24.01 28C24.01 29.1 24.9 30 26 30C27.1 30 28 29.1 28 28C28 26.9 27.1 26 26 26Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercados);
export default __webpack_public_path__ + "static/media/mercados.8b1f175b9feb14daf031f793afe24f8f.svg";
export { ForwardRef as ReactComponent };